import { Box, IconButton, TextField, Typography } from "@mui/material";
import { PropValueLine } from "../../common/PropValueLine";
import { WorldRenderer } from "../../WorldRenderer";
import { FloorVisual } from "../../../visuals/FloorVisual";
import { Edit } from "@mui/icons-material";
import { useEffect } from "react";
import { WREvents } from "../../WREvents";

export function FloorProps({ wr, floor, onUpdate }: {
  wr: WorldRenderer,
  floor: FloorVisual,
  onUpdate: (floor: Partial<FloorVisual>) => void
}) {
  useEffect(() => {
  }, [floor, wr]);
  return (
    <>
      <PropValueLine label='Wall Height' value={
        <TextField
          fullWidth
          type="number"
          value={floor.wallHeight}
          variant="standard"
          size="small"
          onChange={(e) => {
            onUpdate({ wallHeight: parseFloat(e.target.value) });
          }}
        />
      } />
      <PropValueLine label='Geometry' value={
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Typography variant="body2" color="textSecondary">
            {floor.outerWall.length}
          </Typography>
          <IconButton
            size="small"
            onClick={() => {
              wr.emitEvent(WREvents.EditFloor, floor, onUpdate);
            }}
          >
            <Edit />
          </IconButton>
        </Box>
      } />
    </>
  );
} 